import React from "react";
import "rc-slider/assets/index.css";
import {
  Row,
  Col,
  Label,
} from "reactstrap";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import ColorPickerFacade from "../../../../components/UI/Buttons/ColorPickerFacade";
import EditorSlider from "../tools/EditorSlider";
import JirangoSwitch from "../../../../components/UI/Switch/JirangoSwitch";

const defaultBoxShadow = "2px 7px 5px 0px #888888";

class BoxShadowSettings extends React.Component {
  state = {
    isOpen: false
  };
  componentDidMount() {
    if (this.props.boxShadowEnabled) {
      this.setState({ isOpen: true });
    }
  }
  toggleBoxShadow = () => {
    this.setState({ isOpen: !this.state.isOpen });
    if (!this.state.isOpen === false) {
      this.props.onChange(null, "unset", this.props.path);
    } else {
      this.props.onChange(null, defaultBoxShadow, this.props.path);
    }
  };
  parseColorToRgba(color) {
    const { r, g, b, a } = color.rgb;
    return `rgba(${r},${g},${b},${a})`;
  }
  handleChange = (color, e, path) => {
    let boxShadow = "";
    if (this.props.value.split(" ").length > 5)
      boxShadow = defaultBoxShadow
    else boxShadow = this.props.value;

    boxShadow = boxShadow.split(" ");
    let value = color ? this.parseColorToRgba(color) : e;

    if (path.includes("bscol")) path = 4;
    path = parseInt(path);
    boxShadow[path] = `${value}${path !== 4 ? "px" : ""}`;
    boxShadow = boxShadow.join(" ");

    this.props.onChange(null, boxShadow, this.props.path);
  };
  splitString = (value) => {
    if (value === 'unset' || value === 'none') return value;
    else {
      let str = value.split(" ");
      return str.length <= 5 ? str : defaultBoxShadow.split(" ");
    }
  }
  render() {
    const { value } = this.props;
    let boxShadow = this.splitString(value);
    let area = this.props.path.toString().split('.')

    return (
      <React.Fragment>
        <hr />
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="BoxShadow" />
            </Label>
          </Col>
          <Col className="list-setting-item-input" style={{ textAlign: 'right' }}>
            <JirangoSwitch
              onChange={this.toggleBoxShadow}
              isChecked={this.state.isOpen}
            />
          </Col>
        </Row>
        {this.state.isOpen ? (
          <React.Fragment>
            <hr />
            <Row>
              <Col className="list-setting-item-title">
                <Label>
                  <SystemLabel name="BoxShadowColor" />
                </Label>
              </Col>
              <Col className="list-setting-item-item">
                <ColorPickerFacade
                  color={boxShadow[4]}
                  path={area[0] + '.bscol'}
                  onChange={this.handleChange}
                />
              </Col>
              <br />
            </Row>
            <hr />
            <EditorSlider
              label="HorizontalOffset"
              defaultValue={0}
              units={["px"]}
              activeUnit="px"
              onChange={this.handleChange}
              unitChange={() => null}
              path={"0"}
              value={parseInt(boxShadow[0])}
            />
            <hr />
            <EditorSlider
              label="VerticalOffset"
              defaultValue={0}
              units={["px"]}
              activeUnit="px"
              onChange={this.handleChange}
              unitChange={() => null}
              path={"1"}
              value={parseInt(boxShadow[1])}
            />
            <hr />
            <EditorSlider
              label="BlurRadius"
              defaultValue={0}
              units={["px"]}
              activeUnit="px"
              onChange={this.handleChange}
              unitChange={() => null}
              path={"2"}
              value={parseInt(boxShadow[2])}
            />
            <hr />
            <EditorSlider
              label="SpreadRadius"
              defaultValue={0}
              units={["px"]}
              activeUnit="px"
              onChange={this.handleChange}
              unitChange={() => null}
              path={"3"}
              value={parseInt(boxShadow[3])}
            />
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}
export default BoxShadowSettings;
